import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'externalApiKey'

const LIST_API_KEYS = createRequestTypes(prefix, 'LIST_API_KEYS')

export const [LIST_API_KEYS_REQUEST, LIST_API_KEYS_SUCCESS, LIST_API_KEYS_FAILURE] = LIST_API_KEYS

export const listApiKeys = createAction((clientId: string) => ({
  type: LIST_API_KEYS,
  promise: (api: IApi) => api.externalApiKey.list(clientId),
  params: { clientId },
}))

const CREATE_API_KEY = createRequestTypes(prefix, 'CREATE_API_KEY')

export const [CREATE_API_KEY_REQUEST, CREATE_API_KEY_SUCCESS, CREATE_API_KEY_FAILURE] =
  CREATE_API_KEY

export const createApiKey = createAction(
  (clientId: string, data: { label: string; expiresAt?: string }) => ({
    type: CREATE_API_KEY,
    promise: (api: IApi) => api.externalApiKey.create(clientId, data),
    params: { clientId, ...data },
  }),
)

const REVOKE_API_KEY = createRequestTypes(prefix, 'REVOKE_API_KEY')

export const [REVOKE_API_KEY_REQUEST, REVOKE_API_KEY_SUCCESS, REVOKE_API_KEY_FAILURE] =
  REVOKE_API_KEY

export const revokeApiKey = createAction((clientId: string, id: string) => ({
  type: REVOKE_API_KEY,
  promise: (api: IApi) => api.externalApiKey.revoke(clientId, id),
  params: { clientId, id },
}))
